var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dropdown" },
    [
      _vm.currentFlow
        ? _c(
            "p",
            {
              staticClass: "dropdown-toggle mb-0 my-auto bold clickable",
              class: _vm.badge
                ? "badge status-badge complete ml-2"
                : "text-primary",
              style: { backgroundColor: _vm.getSecondaryComplement },
              attrs: {
                id: "dropdown-menu-button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
              },
            },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.getFlowTitle(_vm.currentFlow)) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dropdown-menu",
          attrs: { "aria-labelledby": "dropdown-menu-button" },
        },
        _vm._l(_vm.remainingFlows, function (flow) {
          return _c(
            "a",
            {
              key: flow.key,
              staticClass: "dropdown-item clickable flow-selection",
              on: {
                click: function ($event) {
                  return _vm.showModal(flow.key)
                },
              },
            },
            [_vm._v(_vm._s(flow.title))]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("application-flow-modal", {
        ref: "modal",
        on: { submit: _vm.handleChangeFlow },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }